import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center w-screen h-screen bg-gray-200">
      <div className="flex flex-col items-center space-y-4 text-gray-700">
        <div className="w-16 h-16 border-4 border-t-4 border-gray-300 rounded-full animate-spin border-t-gray-500"></div>
        <span className="text-lg font-semibold tracking-wide">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingScreen;
